import React from 'react';

import { AnyAction } from 'redux';
import { ThunkAction } from '~/Store';
import { selectProductById } from '~/Product';
import downloadFileFromUrl from '~/utils/Download/downloadFileFromUrl';
import { handleError } from '~/ErrorHandler';
import { flashSuccessMessage } from '~/FlashMessage';

/** Structural export payload accepted from API responses and domain Export unions. */
export type ProcessableExport = {
	readonly downloadUrl: string | null;
	readonly asyncNotification: { readonly email: string } | null;
};

export function buildErrorLocation(productErrors: Array<{ productId: string | null }>): ThunkAction<string, AnyAction> {
	return (dispatch, getState) => {
		const { products } = getState();
		const productNames = productErrors
			.map((error) => {
				const product = selectProductById(products, error.productId);
				return product ? `${product.brandName} (${product.dataset.source.country.alpha2})` : null;
			})
			.filter((name) => name !== null);
		return productNames.length > 0 ? `, please check products: ${productNames.join(', ')}` : '';
	};
}

export const processExport = (fileExport: ProcessableExport | null | undefined): ThunkAction<void, any> => {
	return (dispatch) => {
		if (fileExport == null) {
			dispatch(handleError(new Error('Export response missing export payload')));
			return;
		}
		if (fileExport.downloadUrl !== null) {
			downloadFileFromUrl(fileExport.downloadUrl);
		} else if (fileExport.asyncNotification != null) {
			dispatch(
				flashSuccessMessage(
					<>
						Your export request has been enqueued and once it finishes, you'll receive a notification at your email{' '}
						<strong>{fileExport.asyncNotification.email}</strong> with a download link.
					</>
				)
			);
		} else {
			dispatch(handleError(new Error('Export response missing export payload')));
		}
	};
};
